import {
  AddOperationalViewDialogComponent,
  AddWidgetDialogComponent,
  CameraGridsDialogComponent,
  CameraLiveViewDialogComponent,
  EditContentDialogComponent,
  OperationalViewWidgetsPageComponent,
  OperationalViewsTabsComponent,
  ViewListDialogComponent,
  ViewUpdatedToastComponent,
} from './components';
import {
  CameraGridsWidgetComponent,
  CameraLiveViewWidgetComponent,
  ChatChannelWidgetComponent,
  ContentWidgetComponent,
  EmbedCodeWidgetComponent,
  EmbedYoutubeWidgetComponent,
  FacebookLiveWidgetComponent,
  MediaWidgetComponent,
  TwitterEmbedWidgetComponent,
  WebsiteIframeWidgetComponent,
} from './widgets';
import { SnCameraGridActionsService, SnCamerasModule } from '@lib/cameras';

import { AlarmsModule } from '@lib/alarms';
import { AnalyticsWidgetComponent } from './widgets/analytics-widget/analytics-widget.component';
import { AnalyticsWidgetDateComponent } from './components/analytics-widget-date/analytics-widget-date.component';
import { AngularEditorModule } from '@kolkov/angular-editor';
import { CommonModule } from '@angular/common';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { FacebookModule } from 'ngx-facebook';
import { FormEditTitleComponent } from './components/form-edit-title/form-edit-title.component';
import { GoogleMapModule } from '@lib/geo/google/map';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTooltipModule } from '@angular/material/tooltip';
import { NgModule } from '@angular/core';
import { NgxLoadingButtonsModule } from 'ngx-loading-buttons';
import { OpWidgetDialogViewComponent } from './components/op-widget-dialog-view/op-widget-dialog-view.component';
import { OpWidgetsListViewComponent } from './components/op-widgets-list-view/op-widgets-list-view.component';
import { PolylineInfoPopoutComponent } from './components/polyline-info-popout/polyline-info-popout.component';
import { SnButtonModule } from '@lib/ui/button';
import { SnCommonModule } from '@lib/common';
import { SnDataListModule } from '@lib/ui/data-list';
import { SnFormModule } from '@lib/form';
import { SnFormTextareaModule } from '@lib/form/textarea';
import { SnIconModule } from '@lib/ui/icon';
import { SnLocationsModule } from '@lib/locations';
import { SnSearchbarModule } from '@lib/ui/searchbar';
import { SnShareModule } from '@lib/share';
import { SnStatsModule } from '@lib/stats';
import { SnTwilioChatModule } from '@lib/communication/twiliochat';
import { TranslationModule } from '@lib/translation';

@NgModule({
  imports: [
    // Angular
    CommonModule,
    // Material
    MatDialogModule,
    MatCardModule,
    MatTableModule,
    MatTooltipModule,
    MatProgressSpinnerModule,
    MatProgressBarModule,
    MatMenuModule,
    MatIconModule,
    MatListModule,
    MatDividerModule,
    MatButtonModule,
    MatTabsModule,
    // Libs
    SnCommonModule,
    SnDataListModule,
    SnFormModule,
    SnButtonModule,
    SnIconModule,
    SnSearchbarModule,
    SnCamerasModule,
    SnTwilioChatModule,
    FacebookModule.forRoot(),
    AngularEditorModule,
    SnFormTextareaModule,
    SnStatsModule,
    SnLocationsModule,
    SnShareModule,
    NgxLoadingButtonsModule,
    DragDropModule,
    GoogleMapModule,
    AlarmsModule,
    TranslationModule,
  ],
  exports: [
    // Components
    AddWidgetDialogComponent,
    CameraLiveViewWidgetComponent,
    CameraLiveViewDialogComponent,
    CameraGridsWidgetComponent,
    ChatChannelWidgetComponent,
    ContentWidgetComponent,
    EmbedYoutubeWidgetComponent,
    FacebookLiveWidgetComponent,
    ViewUpdatedToastComponent,
    EmbedCodeWidgetComponent,
    CameraGridsDialogComponent,
    TwitterEmbedWidgetComponent,
    WebsiteIframeWidgetComponent,
    MediaWidgetComponent,
    AddOperationalViewDialogComponent,
    OperationalViewWidgetsPageComponent,
    OperationalViewsTabsComponent,
    ViewListDialogComponent,
    FormEditTitleComponent,
    AnalyticsWidgetComponent,
    AnalyticsWidgetDateComponent,
    OpWidgetsListViewComponent,
    OpWidgetDialogViewComponent,
  ],
  declarations: [
    // Components
    AddWidgetDialogComponent,
    CameraLiveViewWidgetComponent,
    CameraLiveViewDialogComponent,
    CameraGridsWidgetComponent,
    ChatChannelWidgetComponent,
    EmbedYoutubeWidgetComponent,
    FacebookLiveWidgetComponent,
    ContentWidgetComponent,
    EditContentDialogComponent,
    ViewUpdatedToastComponent,
    FormEditTitleComponent,
    EmbedCodeWidgetComponent,
    CameraGridsDialogComponent,
    TwitterEmbedWidgetComponent,
    WebsiteIframeWidgetComponent,
    MediaWidgetComponent,
    AddOperationalViewDialogComponent,
    OperationalViewWidgetsPageComponent,
    OperationalViewsTabsComponent,
    ViewListDialogComponent,
    AnalyticsWidgetComponent,
    AnalyticsWidgetDateComponent,
    OpWidgetsListViewComponent,
    OpWidgetDialogViewComponent,
  ],
  providers: [
    SnCameraGridActionsService,
    AnalyticsWidgetComponent,
    PolylineInfoPopoutComponent,
    AnalyticsWidgetDateComponent,
  ],
})
export class SnOperationalViewsModule {}
